/**
 * Represents the possible statuses for an Interactive Site Plan lot.
 */
export default class LotStatus {
  /**
   * Sold lot status
   */
  static get Sold() {
    const configuration = {
      name: 'Sold',
      id: 'Sold',
    };
    return this.getInstance('Sold', configuration);
  }
    
  static get QuickMoveIn() {
    const configuration = {
      name: 'Quick Move In',
      id: 'QuickMoveIn',
    };
    return this.getInstance('QuickMoveIn', configuration);
  }

  static get Inventory() {
    const configuration = {
      name: 'Inventory',
      id: 'Inventory',
    };
    return this.getInstance('Inventory', configuration);
  }

  static get Unreleased() {
    const configuration = {
      name: 'Unreleased',
      id: 'Unreleased',
    };
    return this.getInstance('Unreleased', configuration);
  }

  static fromKey(key) {
    const map = {
      Sold: LotStatus.Sold,
      QuickMoveIn: LotStatus.QuickMoveIn,
      Inventory: LotStatus.Inventory,
      Unreleased: LotStatus.Unreleased,
    };

    return map[key];
  }

    static getInstance(key, configuration) {
      if (!this.instances[key]) {
        this.instances[key] = new LotStatus(configuration);
      }

      return this.instances[key];
    }
  
    constructor(configuration) {
      this.name = configuration.name;
      this.id = configuration.id;
    }
  
    toString() {
      return `${this.name}`;
    }
  }
  
  Object.defineProperty(LotStatus, 'instances', { value: {} });
  